import {Button, Col, Input, Row, Spin, Modal, message, Select} from 'antd';
import TrailLinks from "component/utils/trail_links";
import {aclPermissions, hasPermissions} from "const/ACLPermissions";
import {userEvents} from "const/UserEvents";
import {get, post} from "helper/request";
import {Component} from "react";
import {connect} from "react-redux";
import {loadGroups} from "redux_actions/users.action";
import 'asset/style/add_case.css';
import {getUnauthorizedComponent} from '../component/dashboard/slidelist_utils';
import {error_manager} from "../helper/error_manager";
import {isNull, isSuperuser, openEndPoint, notNull} from "../utils/utils";
import ManageGroup from "./managegroup";
import ManagePermission from "./managepermission";
import {antdSpinLoaderIcon, emailValidationPattern} from "../utils/const";
import cookie from "react-cookies";
import {Divider} from "@mui/material";


class EditUserView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            userId: this.props.match.params.id,
            username: '',
            firstName: '',
            lastName: '',
            email: '',
            organisation: null,
            groups: [],
            showSaveModal: false,
            lastLogin: null,
            createdOn: null,
            lastPasswordChangedOn: null,
            emailValid: true,
            firstNameValid: true,
            isTotpEnabled: false,
            TotpModal: false,
            userRoles: [],
            currentUserRole: null,
        }
    }

    componentDidMount = () => {
        this.getUserInfo();
        this.props.dispatch(loadGroups())
    }

    getUserInfo = async () => {
        this.setState({
            isFetching: true,
        });

        try {
            let url = `/api/user/${this.state.userId}/`;

            const { username } =
                await get(url)
                    .then(data => {
                        this.setState({
                            username: data.username,
                            firstName: data.first_name,
                            lastName: data.last_name,
                            email: data.email,
                            organisation: data.organisation,
                            groups: data?.assigned_groups?.map(g => g?.id),
                            createdOn: hasPermissions([aclPermissions.view_other_user_events])
                                ? (new Date(data.date_joined)).toLocaleString() : null,
                            lastLogin: hasPermissions([aclPermissions.view_other_user_events]) ?  data.last_login
                                ? (new Date(data.last_login)).toLocaleString() : "N/A": null,
                            isTotpEnabled: data.isTotpEnabled,
                            currentUserRole: notNull(data.user_role) ? data.user_role.role_name : null
                        });
                        return { username: data.username }
                    })

            await Promise.all([
                this.getUserEvents(username),
                this.fetchUserRoles(username)
            ])

        } catch (err) {
            console.error(err.message)
            error_manager("Unable to fetch User Details. Contact Admin", err)
        } finally {
            this.setState({ isFetching: false })
        }
    }


    getUserEvents = (username) => {
        const url = encodeURI(`/api/get_user_events/${username}/`)

        return get(url)
            .then(({events}) => {
                const passwordChanged = events.find(({type}) => type === userEvents.PASSWORD_UPDATED)

                this.setState({
                    lastPasswordChangedOn: hasPermissions([aclPermissions.view_other_user_events]) ? passwordChanged?.timestamp ?
                        (new Date(passwordChanged.timestamp).toLocaleString())
                        : "N/A" : null
                })
            })
            .catch(err => {
                if (err?.response?.data !== "user doesn't have required permissions") {
                    error_manager("Unable to fetch user events", err)
                }
            })
    }

    fetchUserRoles = (username) => {
        const url = encodeURI(`/api/get_user_role/${username}/`);
        return get(url)
          .then((response) => {  
            this.setState({
              userRoles: response.all_roles,
            });
          })
          .catch(err => {
            console.error('Error fetching user roles:', err);
          })
    };

    handleRoleChange = (value) => {
        this.setState({
            currentUserRole: value
        })
    }

    updateField = (e) =>
        this.updateUser(e.target.name, e.target.value)

    updateUser = (field, value) => {
        this.setState({ [field]: value })
    }

    saveUser = () => {
        this.setState({
            isFetching: true,
        });

        let firstNameValid = true
        if (this.state.firstName.length <= 0) {
            firstNameValid = false
        }

        const emailValid = emailValidationPattern.test(this.state.email);
        if (!emailValid || !firstNameValid) {
            this.setState({
                emailValid: emailValid,
                firstNameValid: firstNameValid,
                isFetching: false,
            });
            const container = document.getElementById('topEl');
            if (container) {
                container.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
            return;
        }

        const data = {
            id: this.state.userId,
            username: this.state.username,
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            email: this.state.email,
            groups: this.state.groups,
            organisation: this.state.organisation
        }

        const promises = []
        promises.push(this.updateUserInfo(data))
        promises.push(this.updateGroup(data))

        const userRoleData = {
            role_name: this.state.currentUserRole,
            username: this.state.username,
        }   
        promises.push(this.setUserRole(userRoleData))

        Promise.allSettled(promises)
            .then(() => {
                if (this.state.username !== cookie.load('username')) {
                    openEndPoint("/accesscontrol/")
                }
            })
            .catch(err => error_manager("Couldn't update user. Contact Admin", err))
            .finally(() => this.setState({ isFetching: false }))
    }

    updateUserInfo = (data) => {
        const url = "/api/update_user/"
        return post(url, data)
    }

    updateGroup = async ({ id, username, groups }) => {
        let url = encodeURI(`/api/user/${id}/`)
        const { groups: currGroups } = await get(url)

        const organisation = this.state.organisation
        const dataObj = {
            update_member_usernames: [username],
            organisation,
        }

        const allGroups = Object.values(this.props.allGroups)
        const promises = []
        url = '/api/update_members_in_group/'

        const addGroups =
            groups
                .filter(e => !currGroups.includes(e))
                .map(g => allGroups.find(e => e.id === g)?.name)

        dataObj['action'] = "add"
        for (const group of addGroups) {
            if (!group) continue

            const data = { ...dataObj, group }
            const promise = post(url, data)
            promises.push(promise)
        }

        const removeGroups =
            currGroups
                .filter(e => !groups.includes(e))
                .map(g => allGroups.find(e => e.id === g)?.name)

        dataObj['action'] = "remove"
        for (const group of removeGroups) {
            if (!group) continue

            const data = { ...dataObj, group }
            const promise = post(url, data)
            promises.push(promise)
        }

        return Promise.allSettled(promises)
    }

    setUserRole = (userRoleData) => {
        const url = "/api/set_user_role/"
        return post(url, userRoleData)
    }

    showTotpModal = () => {
        this.setState({ TotpModal: true });
    };

    hideTotpModal = () => {
        this.setState({ TotpModal: false });
    }

    handleDisableTotp = () => {   
        const userId = this.state.userId; 
        post("/api/disable_mfa_totp/", { user_id: userId })
            .then((response) => {
                if (response.success) {
                    message.success(response.message);
                    this.setState({
                        isTotpEnabled: false, 
                    })
                    this.hideTotpModal();
                } else {
                    message.error(response.message);
                }
            })
            .catch((error) => {
                message.error(error.response.data.message);
            });
    };

    render() {

        if (isNull(this.state.organisation) || isNull(this.state.username)) return null;

        return (
            hasPermissions([aclPermissions.update_user]) ?
                <div>
                    <div style={{backgroundColor: "white", padding: "20px"}} className={"full-parent"}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{fontSize: 30, fontWeight: 400, marginLeft: 0}}>Edit User</div>
                            <div style={{marginLeft: 'auto', marginRight: 50}}>
                                <TrailLinks trails={[
                                    {label: 'Home', link: '/'},
                                    {label: 'Manage Users', link: '/accesscontrol/'},
                                    {label: 'Edit User', link: ''}
                                ]}/>
                            </div>
                        </div>
                        <Divider color={"#000"} style={{opacity: "0.2", margin: 5}}/>
                        <Spin spinning={this.state.isFetching} indicator={antdSpinLoaderIcon}>
                            <Row style={{padding: 20}}>
                                <Row>
                                    <Col span={24} style={{paddingLeft: "20px"}}>
                                        <Button onClick={() => this.setState({showSaveModal: true})}
                                                disabled={!(this.state.username.length > 0)}
                                                style={{
                                                    float: "right",
                                                }}
                                                type="primary" ghost
                                        >
                                            Save
                                        </Button>
                                        <div style={{fontSize: 20, fontWeight: 400}}>User Details</div>
                                        <Divider color={"#000"} style={{opacity: "0.2", marginTop: 10}}/>
                                    </Col>
                                </Row>
                                <Col xl={12} xs={24}>
                                    <Row style={{marginTop: "30px"}}>
                                        <Col xl={15} offset={1} xs={22}>
                                            <b>Username</b>
                                            &nbsp;
                                            <span style={{color: "#f00"}}>*</span>
                                        </Col>
                                        <Col xl={15} offset={1} xs={22}>
                                            <Input placeholder="Username" value={this.state.username}
                                                   className="input-field-add-user" style={{color: 'black'}}
                                                   autoComplete="off" disabled
                                                   type={"secondary"}
                                            />
                                        </Col>

                                    </Row>

                                    <Row style={{marginTop: "30px"}}>
                                        <Col xl={15} offset={1} xs={22}>
                                            <b>Email</b>
                                        </Col>
                                        <Col xl={15} offset={1} xs={22}>
                                            <Input placeholder="Email" value={this.state.email}
                                                   className="input-field-add-user"
                                                   name="email" onChange={this.updateField}
                                                   type={"secondary"}
                                                   autoComplete="off"/>
                                        </Col>
                                        {!this.state.emailValid && <Col span={23} offset={1}>
                                            <div style={{fontSize: 14, color: "red"}}>
                                                Enter a valid email, For example:{" "}
                                                <span style={{fontStyle: "italic"}}>user@example.com</span>
                                            </div>
                                        </Col>}
                                    </Row>

                                    <Row style={{marginTop: 30}}>
                                        <Col xl={7} offset={1} xs={11}>
                                            <b>First Name</b>
                                        </Col>
                                        <Col xl={7} offset={1} xs={11}>
                                            <b>Last Name</b>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xl={7} offset={1} xs={11}>
                                            <Col>
                                                <Input placeholder="First Name" value={this.state.firstName}
                                                       className="input-field-add-user" name="firstName"
                                                       onChange={this.updateField} autoComplete="off"/>
                                            </Col>
                                            {!this.state.firstNameValid && <Col>
                                                <div style={{fontSize: 14, color: "red"}}>
                                                    * First name can't be empty
                                                </div>
                                            </Col>

                                            }
                                        </Col>
                                        <Col xl={7} offset={1} xs={10}>
                                            <Input placeholder="Last Name" value={this.state.lastName}
                                                   className="input-field-add-user"
                                                   name="lastName" onChange={this.updateField}
                                                   autoComplete="off"/>
                                        </Col>
                                    </Row>
                                    <Row style={{marginTop: 30}}>
                                        <Col xl={7} offset={1} xs={11}>
                                            <b>Set User Role</b>
                                        </Col>
                                        {isSuperuser() && <Col xl={7} offset={1} xs={11}>
                                            <b>Multi-factor authentication</b>
                                        </Col>}
                                    </Row>
                                    <Row>
                                        <Col xl={7} offset={1} xs={11}>
                                            <Select
                                                style={{width: "100%"}}
                                                placeholder="Select a user role"
                                                value={this.state.currentUserRole}
                                                onChange={this.handleRoleChange}
                                            >
                                                {this.state.userRoles.map(role => (
                                                    <Select.Option key={role.id} value={role.role_name}>
                                                        {role.role_name}
                                                    </Select.Option>
                                                ))}
                                                <Select.Option value={null}>Not Assigned</Select.Option>
                                            </Select>
                                        </Col>
                                        {isSuperuser() && <Col xl={7} offset={1} xs={10}>
                                            <Button

                                                onClick={this.showTotpModal}
                                                style={this.state.isTotpEnabled ? {
                                                    borderColor: "rgb(255,0,0)", color: "rgb(255,0,0)",
                                                    width: "100%"
                                                } : {width: "100%"}}
                                                disabled={!this.state.isTotpEnabled}
                                                className="input-field-add-user"
                                            >
                                                {this.state.isTotpEnabled ? 'Disable TOTP' : 'TOTP Already Disabled'}
                                            </Button>
                                            <Modal
                                                title="Disable TOTP"
                                                visible={this.state.TotpModal}
                                                onCancel={this.hideTotpModal}
                                                footer={[
                                                    <div style={{textAlign: "center"}}>
                                                        <Button key="disable" type="primary"
                                                                onClick={this.handleDisableTotp}>
                                                            Disable
                                                        </Button>
                                                    </div>,
                                                ]}
                                            >
                                                <p style={{color: 'red'}}>Warning: Disabling TOTP has security
                                                    implications!</p>
                                                <p>Disabling TOTP will remove an extra layer of security. Please
                                                    make sure the user understands the risks involved.</p>
                                            </Modal>
                                        </Col>}
                                    </Row>

                                    <Row gutter={[0, 24]} style={{marginTop: "20px"}}>
                                        <Col span={23} offset={1}>
                                            {this.state.createdOn && <div>
                                                User created on <span
                                                style={{fontWeight: "bold"}}>{this.state.createdOn}</span>
                                            </div>}
                                            {this.state.lastLogin && <div>
                                                User last logged in on <span
                                                style={{fontWeight: "bold"}}>{this.state.lastLogin}</span>
                                            </div>}
                                            {this.state.lastPasswordChangedOn && <div>
                                                User last password changed at <span
                                                style={{fontWeight: "bold"}}>{this.state.lastPasswordChangedOn}</span>
                                            </div>}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <br/>
                            <div>
                                <ManageGroup
                                    groups={this.state.groups}
                                    organisation={this.state.organisation}
                                    setGroups={(groups) => this.setState({groups})}
                                />
                            </div>
                            <div>
                                <ManagePermission
                                    username={this.state.username}
                                    organisation={this.state.organisation}
                                    showSaveModal={this.state.showSaveModal}
                                    setShowSaveModal={(showSaveModal) => this.setState({showSaveModal})}
                                    saveUser={() => this.saveUser()}
                                />
                            </div>
                            <div>
                                <Divider color={"#000"} style={{opacity: "0.2", margin: 10, marginRight: 20}}/>
                                <Row span={4} type="flex" justify="space-between"
                                     style={{flexDirection: "row-reverse"}}>
                                    <Button onClick={() => this.setState({showSaveModal: true})}
                                            disabled={!(this.state.username.length > 0)}
                                            style={{

                                                marginTop: 5,
                                                marginRight: 20
                                            }}
                                            type="primary" ghost
                                    >
                                        Save
                                    </Button>
                                </Row>
                            </div>
                        </Spin>
                    </div>
                </div>
                : <div>
                    {getUnauthorizedComponent()}
                </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        allSlides: state.slidesReducer,
        allIds: Object.keys(state.slidesReducer),
        numPages: state.dashboardReducer.numPages,
        urlState: state.searchReducer,
        allUsernames: state.searchUserReducer.usernames,
        allGroups: state.searchUserReducer.groups,
    }
}

export default connect(mapStateToProps)(EditUserView);
